import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";

export default function CompanyView(props: any) {
  useEffect(() => {
    console.log("Activity On mount :", props);
  }, []);
  return (
    <>
      <div className="container mb-4">
        <div className="card ">
          <div className="card-body">
            <h5 className="card-title  pt-4 ps-2">Company name</h5>
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <h5 className="card-title  pt-4">Rating</h5>
                </div>

                <div className="col-6">
                  <button type="button" className="btn btn-primary mt-4">
                    Follow
                  </button>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="col-lg-6">
          <div className="card ">
            <div className="card-body">
              <div className="container">
                <div className="row">
                  <ul className="card-text">Total Work</ul>
                  <ul className="card-text">Total Revenue</ul>
                  <ul className="card-text">Pending Amount</ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
